import React from 'react';
import { Table, Empty, Button, Input, Checkbox, Form, Tooltip,Select } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';

const { Option } = Select;


export default function DetalleServicioModal(props) {
    return (
        <div>
            <Table
                className={'table-servicio'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row.identifier)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 80,
                        ellipsis: true,
                        fixed: 'left',
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 300,
                        ellipsis: true,
                        fixed: 'left',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {
                                        props.onGetFieldDecorator(`arrNombre[${row.nombre}]`, {
                                            initialValue: value
                                        })(
                                            <Input
                                                placeholder="Nombre"
                                                autoComplete="off"
                                                className="text-left"
                                                readOnly={true}
                                                onClick={(e) => props.onChangeNameProduct(row)}
                                            />
                                        )
                                    }

                                </Form.Item>
                            )
                        }
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'nombreUnidadMedida',
                        key: 'nombreUnidadMedida',
                        width: 120,
                        ellipsis: true
                    },
                    {
                        title: 'Tipo IGV',
                        dataIndex: 'idImpuesto',
                        key: 'idImpuesto',
                        width: 220,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridImpuesto[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(

                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo IGV"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onCalculateDetail(row.identifier, "arridImpuesto", option.key, 5, row); }}
                                        >
                                           {props.tipoAfectacion.map(item => (
                                                ['10', '20', '30', '40'].includes(item.codigoSunat) ?
                                                    <Option key={item.id} value={item.id}>{item.nombre}</Option> :
                                                    null
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Valor Unitario',
                        dataIndex: 'precioUnitarioSinIGV',
                        key: 'precioUnitarioSinIGV',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioUnitario[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            disabled={props.precioUnitarioDisabled}
                                            placeholder="V.  Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row.identifier, "arrPrecioUnitario", e.target.value, 5, row)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Precio Unitario',
                        dataIndex: 'precioUnitario',
                        key: 'precioUnitario',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecio[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            disabled={props.precioUnitarioDisabled}
                                            placeholder="P. Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => props.onCalculateDetail(row.identifier, "arrPrecio", e.target.value, 5, row)}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(0),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Formato (0)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Cantidad"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row.identifier, "arrCantidad", e.target.value, 0, row)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Sub Total',
                        dataIndex: 'subTotal',
                        key: 'subTotal',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrSubTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'IGV',
                        dataIndex: 'igv',
                        key: 'igv',
                        align: 'center',
                        width: 80,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrIgv[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Total',
                        dataIndex: 'total',
                        key: 'total',
                        fixed: 'right',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            disabled={props.totalDisabled}
                                            placeholder="Total"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row.identifier, "arrTotal", e.target.value, 2, row)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    }
                ]}
            />
        </div>
    );
}